<div class="actions-case-card">
  <div class="case-layout">
    <a
      *ngIf="showImage"
      class="case-image"
      routerLink="/client/claim/{{ claim!.id }}"
    >
      <!-- Fundo desfocado decorativo: mesma imagem, cover-fit, apenas visual -->
      <div
        class="case-image__backdrop"
        aria-hidden="true"
        [style.background-image]="
          'url(' + claim?.cp_case?.configuration.images?.high_res + ')'
        "
      ></div>
      <!-- Imagem completa, sempre visível (sem corte) -->
      <img
        class="case-image__fg"
        [src]="claim?.cp_case?.configuration.images?.high_res"
        alt=""
      />
    </a>

    <div class="card-body">
      <div class="card-top">
        <div class="row status">
          <div class="chip">
            <p>
              {{ claim?.cp_case?.status! | caseStatus | translate }}
            </p>
          </div>

          <div class="outstanding-message">
            <span
              [class.green]="!pendingNumber || pendingNumber === 0"
              [class.red]="pendingNumber && pendingNumber > 0"
              class="circle"
            ></span>

            <span class="label" *ngIf="pendingNumber > 0"
              >{{pendingNumber}} {{ 'pending '
              + (pendingNumber === 1 ? "action" : "actions")  | translate }}</span
            >

            <span
              class="label"
              *ngIf="!pendingNumber || pendingNumber === 0"
              >{{'Nopendingactions' | translate}}</span
            >
          </div>
        </div>
        <div class="row">
          <h4>
            {{ claim?.cp_case?.summary }}
          </h4>
        </div>
      </div>

      <p class="actions-required">{{'Actionsrequired' | translate}}</p>

      <app-outstanding-actions
        *ngIf="claim"
        [claimId]="claim.id"
        (outstandingActions)="changeActions($event)"
      ></app-outstanding-actions>

      <button
        (click)="navigateToClaim()"
        class="def-button view-details"
        *ngIf="showDetails"
      >
        {{'View details'|translate}}
      </button>
    </div>
  </div>
</div>
